module.exports = __webpack_public_path__ + "static/media/Inter-BlackItalic.20baa29a.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Inter/Inter-BlackItalic.woff
// module id = 677
// module chunks = 21